import { faCheckCircle, faInfoCircle, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { push } from "connected-react-router";
import * as React from 'react';
import { SpinnerComponent } from 'react-element-spinner';
import { connect } from 'react-redux';
import { toastr } from "react-redux-toastr";
import { Col, FormGroup, Label, Row } from "reactstrap";
import { CallAxiosRequest } from '../../Helpers/axiosHelpers';
import { YoonitRequest } from '../../Interfaces/Interfaces';
import { Login, Logout } from '../../redux/actions/AuthActions';
import { IStore } from '../../redux/constants';
import { withTranslation } from 'react-i18next';

const mapStateToProps = (state: IStore) => ({
    userData: state.auth.UserData,
    lang: state.language.value,
    history: state.history,
    URL: state.auth.UserData.yoonitGetURL,
    theme: state.theme
});
const dispatchProps = { push, Login, Logout }
export interface SubscriptionsProps {
    lang: string;
    userData: any;
    push: any;
    URL: string;
    theme: any;
    t: any;
}

export interface SubscriptionsState {
    isLoading: boolean;
    showSubscription: boolean;
    Allocation: AllocationItems[];
    Modules: ModuleItems[];
    Subscription: SubscriptionItems[];
    FilteredModules: ModuleItems[];
    AllocationID: string;
    AllocationAdmins: number;
    AllocationClients: number;
    SubId: string;
    selectId: string;
}
class AccountClass {
    Allocation: AllocationItems[] = [] as any;
    Modules: ModuleItems[] = [] as any;
    Subscription: SubscriptionItems[] = [] as any;
}
class AllocationItems {
    AllocationAdmins: string = '';
    AllocationClients: string = '';
    AllocationExpiration: string = '';
    AllocationName: string = '';
    SubscriptionID: number = 0;
    AllocationID: number = 0;
}
class ModuleItems {
    AllocationID: number = 0;
    ModuleName: string = '';
    ModuleDescription: string = '';
    Icon: string = '';
}
class SubscriptionItems {
    SubscriptionID: number = 0;
    SubscriptionName: string = '';
    SubscriptionDesc: string = '';
}
class Subscriptions extends React.Component<SubscriptionsProps, SubscriptionsState> {
    state = {
        isLoading: false,
        Allocation: [] as any,
        Modules: [] as any,
        Subscription: [] as any,
        FilteredModules: [] as any,
        showSubscription: false,
        AllocationID: "",
        AllocationAdmins: 0,
        AllocationClients: 0,
        SubId: "",
        selectId: ""

    }
    componentDidMount() {
        this.LoadSubscriptions();
    }

    LoadSubscriptions = () => {
        let ActionParams: YoonitRequest<any> = {
            ObjData: {
            }
        };
        this.setState({ isLoading: true });

        CallAxiosRequest<any, AccountClass>(
            this.props.userData.TechAPIURL,
            `Dashboard/Get`,
            ActionParams,
            { token: this.props.userData.Token },
            (res: any) => {
                this.SucessManual(res);
                this.setFirstSubscription();
            },
            () => {
                this.setState({ isLoading: false });
                toastr.error('', this.props.t('ErrorContactingServer'));
            },
            (value: any) => String(value)
        )
    }
    SubscriptionsList = (SubId: string, AllocationID: string, AllocationAdmins: number, AllocationClients: number) => {
        this.setState({
            selectId: SubId,
            showSubscription: true,
            AllocationID, AllocationAdmins, AllocationClients
        });
    }
    setFirstSubscription = () => {
        if (this.state.Subscription && this.state.Subscription[0].SubscriptionID && this.state.Allocation && this.state.Allocation[0].SubscriptionID) {
            this.setState({ SubId: this.state.Subscription && this.state.Subscription[0].SubscriptionID ? this.state.Subscription[0].SubscriptionID : 0});
            for (var i = 0; i < this.state.Allocation.length; i++) {
                if (this.state.SubId === this.state.Allocation[i].SubscriptionID) {
                    this.setState({ AllocationID: this.state.Allocation && this.state.Allocation[i].AllocationID ? this.state.Allocation[0].AllocationID : 0 });
                    this.setState({
                        showSubscription: true,
                        AllocationAdmins: this.state.Allocation[0].AllocationAdmins, AllocationClients: this.state.Allocation[0].AllocationClients
                    }, () => this.SubscriptionsList(this.state.SubId, this.state.AllocationID, this.state.AllocationAdmins, this.state.AllocationClients));
                }
            }
        }
    }

    render() {
        return (
            <div className="m20">
                <SpinnerComponent loading={this.state.isLoading} position="inline" color="#00ad0f" />
                <div className={this.state.isLoading ? "blurBackground " : ""}>
                    <Label className="font-20 text-darkBlack d-block mb-3 text-uppercase t-bold">  {this.props.t('YourPlanDetails')}: </Label>
                    {this.state.Subscription ?
                        <Row className="d-block justify-content-center " >
                            {this.state.Subscription.map((SubscriptionItem: any) => {
                                return (
                                    <>
                                        {this.state.Allocation ?
                                            <>
                                                {this.state.Allocation.map((AllocationItem: any, i: number) => {
                                                    if (SubscriptionItem.SubscriptionID === AllocationItem.SubscriptionID)
                                                        return (
                                                            <Col key={i} md={3} className={this.state.selectId === SubscriptionItem.SubscriptionID ? "d-inline-flex align-self-center justify-content-center mt-3 mb-3 backgroundCard2 p20 cursor-pointer selectedBorder" : "d-inline-flex align-self-center justify-content-center mt-3 mb-3 backgroundCard2 p20 cursor-pointer notSelectedBorders"} onClick={() => this.SubscriptionsList(SubscriptionItem.SubscriptionID, AllocationItem.AllocationID, AllocationItem.AllocationAdmins, AllocationItem.AllocationClients)}>
                                                                <Col md={4} className=" d-flex align-items-center cursor-pointer">
                                                                    <div className="d-flex align-items-center cursor-pointer">
                                                                        <FontAwesomeIcon icon={faUserCircle} className={this.state.selectId === SubscriptionItem.SubscriptionID ? "profileIconSelected text-center  d-flex justify-content-center" : "profileIcon text-center  d-flex justify-content-center"} />
                                                                    </div>
                                                                </Col>
                                                                <Col md={8} className="align-self-center cursor-pointer">
                                                                    <Label className={this.state.selectId === SubscriptionItem.SubscriptionID ? "font-16 text-white d-block cursor-pointer" : "font-16 LabelCreate2 d-block cursor-pointer"} > {this.props.t('SubscriptionName')}: </Label>
                                                                    <Label className={this.state.selectId === SubscriptionItem.SubscriptionID ? "font-16 text-white d-block cursor-pointer" : "font-16 LabelCreate2 d-block cursor-pointer"}> {SubscriptionItem.SubscriptionName} </Label>
                                                                    <Label className={this.state.selectId === SubscriptionItem.SubscriptionID ? "font-16 text-white d-block cursor-pointer" : "font-16 LabelCreate2 d-block cursor-pointer"}> {this.props.t('ExpirationDate')}: </Label>
                                                                    <Label className={this.state.selectId === SubscriptionItem.SubscriptionID ? "font-16 text-white d-block cursor-pointer" : "font-16 LabelCreate2 d-block cursor-pointer"}> {AllocationItem.AllocationExpiration} </Label>
                                                                </Col>

                                                            </Col>
                                                        )
                                                })
                                                }
                                            </>
                                            :
                                            <></>
                                        }
                                    </>
                                )
                            })}
                        </Row>

                        :
                        <></>
                    }
                    {this.state.showSubscription &&
                        <>
                        <Label className="font-20 text-darkBlack d-block mb-3 text-uppercase t-bold mt-3"> {this.props.t('YourModules')}:  </Label>
                            {this.renderModules()}
                        </>
                    }
                </div>
            </div>
        );
    }

    SucessManual = (res: any) => {
        this.setState({ isLoading: false });
        if (res.data.LiveRes) {
            if (res.data.LiveRes) {
                this.setState({
                    Allocation: res.data.LiveRes.Allocation,
                    Modules: res.data.LiveRes.Modules,
                    Subscription: res.data.LiveRes.Subscription,
                });
                const array = this.state.Modules ? this.state.Modules.filter((ModulesItem: any, i: number, arr: any) => arr.findIndex((item: any) => item.ModuleName === ModulesItem.ModuleName) === i) : null;
                this.setState({ FilteredModules: array });
            }
        }
    }
    renderModules = (): React.ReactNode => {
        return <>
            {this.state.Modules ?
                <Row className="d-block justify-content-center ">
                    {this.state.FilteredModules.map((ModulesItem: any) => {
                        let opacity = '', checkIcon = '';
                        if (this.state.Modules.findIndex((item: any) => item.ModuleName === ModulesItem.ModuleName && item.AllocationID === this.state.AllocationID) > -1) {
                            checkIcon = ' checkedIcon';
                        } else {
                            checkIcon = ' unCheckedIcon';
                            opacity = ' opacity8';
                        }
                        return (
                            <Col md={3} className={"d-inline-flex align-self-center justify-content-center mt-3 mb-3 backgroundCard p20 addShadow" + opacity}>
                                <div className="w100p">
                                    <Row className="d-block align-self-center justify-content-center mb-2">
                                        <Col md={12} >
                                            <Label className="font-16 text-white d-block text-center text-uppercase t-bold"  > {ModulesItem.ModuleName} </Label>
                                        </Col>
                                    </Row>
                                    <Row className="d-block align-self-center justify-content-center ">
                                        <Col md={12}>
                                            <FormGroup>
                                                <i className={`${ModulesItem.Icon} text-center iconLicense  d-flex justify-content-center`} aria-hidden="true"></i>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row className="d-flex align-items-center mb-2 h104">
                                        <Col md={12}>
                                            <FormGroup>
                                                <Label className="font-12 LabelCreate2 TextWhite d-block text-center"  ><FontAwesomeIcon icon={faInfoCircle} className="mr-2" /> {ModulesItem.ModuleDescription} </Label>

                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <div className="divRight">
                                        <div className="p-2"><FontAwesomeIcon icon={faCheckCircle} className={"mr-2" + checkIcon} /></div>
                                    </div>

                                </div>
                            </Col>
                        )
                    })
                    }
                </Row>
                :
                <></>
            }
            <Label className="font-20 text-darkBlack d-block mb-3 text-uppercase t-bold mt-3"> {this.props.t('UsersAvailable')}:  </Label>
            <Row className="d-block justify-content-center ">
                <Col md={3} className="d-inline-flex align-self-center justify-content-center mt-3 mb-3 backgroundCard p20 addShadow">
                    <div>
                        <Row className="d-block align-self-center justify-content-center mb-2">
                            <Col md={12} >
                                <Label className="font-16 text-white d-block text-center text-uppercase t-bold"  > {this.props.t('Clients')} </Label>
                            </Col>
                        </Row>
                        <Row className="d-block align-self-center justify-content-center ">
                            <Col md={12}>
                                <FormGroup>
                                    <i className="fas fa-users text-center iconLicense  d-flex justify-content-center" aria-hidden="true"></i>

                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className="d-block align-self-center justify-content-center mb-2">
                            <Col md={12}>
                                <FormGroup>
                                    <Label className="font-16 text-white  d-block text-center t-bold"  >{this.state.AllocationClients} </Label>
                                    <Label className="font-16 LabelCreate2 TextWhite d-block text-center"  > {this.props.t('TotalClients')} </Label>
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col md={3} className="d-inline-flex align-self-center justify-content-center mt-3 mb-3 backgroundCard p20 addShadow">
                    <div>
                        <Row className="d-block align-self-center justify-content-center mb-2">
                            <Col md={12} >
                                <Label className="font-16 text-white d-block text-center text-uppercase  t-bold"  > {this.props.t('Admins')} </Label>
                            </Col>
                        </Row>
                        <Row className="d-block align-self-center justify-content-center ">
                            <Col md={12}>
                                <FormGroup>
                                    <i className="fas fa-user-tie text-center iconLicense  d-flex justify-content-center" aria-hidden="true"></i>

                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className="d-block align-self-center justify-content-center mb-2">
                            <Col md={12}>
                                <FormGroup>
                                    <Label className="font-16 text-white  d-block text-center t-bold"  >{this.state.AllocationAdmins} </Label>
                                    <Label className="font-16 LabelCreate2 TextWhite d-block text-center"  > {this.props.t('TotalAdmins')} </Label>
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </>;
    }
}
export default withTranslation()(connect(mapStateToProps, dispatchProps)(Subscriptions));
